const isShareResumeEnabled = () => {
    return process.env.MIX_SHOW_SHARE_RESUME === 'true'
}

export {
    isShareResumeEnabled
}
